<template>
  <div class="message-container">
    <div class="d-flex flex-grow-1 flex-column justify-space-between">
      <vue-scroll style="width: 100%; height: calc(100vh - 280px) !important;">
        <div></div>
      </vue-scroll>
    </div>
    <div
      class="text-center mb-2 d-flex"
      style="position: relative; height: 40px;"
    >
      <v-pagination
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
        v-model="currentPage"
        :length="1000"
        total-visible="10"
      />
      <div
        style="
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate(-30px, -50%);
        "
        class="d-flex align-center"
      >
        <v-btn small class="white--text" color="blue">跳转</v-btn>
        <input
          type="text"
          style="
            width: 60px;
            border: 1px solid;
            outline: none;
            border-radius: 3px;
            padding: 0 5px;
            margin: 0 5px;
          "
          placeholder=""
        />页
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageCenter",
  data() {
    return {
      currentPage: 1,
      results: [
        {
          id: 1,
          name: "dd332",
          active: false,
          title: "Disodium Tetraoxotellurate",
          anx: "AB2X4",
          structured: " Na2 Te O4",
        },
        {
          id: 2,
          name: "dd33d2",
          active: true,
          title: "Europium(II) Silicate - Beta",
          anx: "AB2X4",
          structured: "Eu2 Si O4",
        },
        {
          id: 3,
          name: "ddd332",
          active: true,
          title: "Lead Titanate",
          anx: " ABX3",
          structured: "Pb (Ti O3)",
        },
        {
          id: 4,
          name: "dd3da32d",
          active: true,
          title: "Lead Titanium Zirconium Oxide *",
          anx: "ABX3",
          structured: "Pb Zr0.9 Ti0.1 O3",
        },
        {
          id: 5,
          name: "dd332dad",
          active: true,
          title: "Thorium Silicate",
          structured: "Th (Si O4)",
          anx: "ABX4",
        },
        {
          id: 6,
          name: "dd3s3d",
          active: true,
          title: "Chromium Manganese Fluoride",
          structured: "Mn Cr F5",
          anx: "ABX5",
        },
        {
          id: 7,
          name: "dd3dada32d",
          active: true,
          title: "Silver Dicyanonitrocarbonate\n",
          anx: "ABC3X2Y2",
          structured: " Ag C (C N)2 N O2",
        },
        {
          id: 8,
          name: "dd332dasad",
          active: true,
          title: "Sodium Calcium Hydrogensilicate",
          structured: "Na Ca (H Si O4)",
          anx: "ABCX4",
        },
        {
          id: 9,
          name: "dd3s3dd",
          active: true,
          title: " Disodium Iron(III) Nickel Fluoride",
          structured: "Na2 Ni Fe F7",
          anx: "ABC2X7",
        },
      ],
    };
  },
};
</script>

<style scoped></style>
